import React from 'react';
import { Box, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import useCaravanaStyles from '../../styles/kozelDarkQuiz/caravana';
import magician from '../../assets/images/kozel_dark_quiz/magician.png';

interface EventData {
    magazin: string;
    zi: string;
    data: string;
    interval: string;
    durata: string;
}

const eventsData: EventData[] = [
    {
        magazin: "CARREFOUR / VULCAN",
        zi: "Luni",
        data: "20.10.2025",
        interval: "17:00 - 20:00",
        durata: "3h"
    },
    {
        magazin: "CORA / LUJERULUI",
        zi: "Marti",
        data: "21.10.2025",
        interval: "17:00 - 20:00",
        durata: "3h"
    },
    {
        magazin: "CARREFOUR / ORHIDEEA \n Eveniment Magician",
        zi: "Joi",
        data: "23.10.2025",
        interval: "17:00 - 20:00",
        durata: "3h"
    },
    {
        magazin: "CARREFOUR / PARK LAKE",
        zi: "Vineri",
        data: "24.10.2025",
        interval: "17:00 - 20:00",
        durata: "3h"
    },
    {
        magazin: "CARREFOUR / BANEASA NR. 7 \n Eveniment Magician",
        zi: "Sambata",
        data: "25.10.2025",
        interval: "11:00 - 14:00",
        durata: "3h"
    },
    {
        magazin: "CARREFOUR / COLOSSEUM",
        zi: "Duminica",
        data: "26.10.2025",
        interval: "11:00 - 14:00",
        durata: "3h"
    },
    {
        magazin: "CARREFOUR / CLUJ NR. 10",
        zi: "Marti",
        data: "28.10.2025",
        interval: "17:00 - 20:00",
        durata: "3h"
    }
];


const Caravana = () => {
    const classes = useCaravanaStyles();

    return (
        <Box className={classes.container}>
            {/* Title Section */}
            <Box className={classes.titleSection}>
                <Typography variant="h1" className={classes.mainTitle}>
                    CARAVANA KOZEL
                </Typography>
                <Typography className={classes.subtitleText}>
                    Vino să asiști la un super show de magie marca Vlad Grigorescu.<br />
                    Save the date!
                </Typography>
            </Box>

            {/* Magician Section */}
            <Box className={classes.magicianSection}>
                <img src={magician} alt="Magician Vlad Grigorescu" className={classes.magicianImage} />
            </Box>

            {/* Events Section */}
            <Box className={classes.eventsSection}>
                {/* Calendar Icon */}
                <Box className={classes.calendarIconContainer}>
                    <CalendarMonthIcon className={classes.calendarIcon} />
                </Box>

                {/* Events Grid */}
                <Box className={classes.eventsGrid}>
                    {eventsData.map((event, index) => (
                        <Box key={index} className={classes.eventCard}>
                            <Typography className={classes.eventMagazin}>
                                {event.magazin}
                            </Typography>
                            <Box className={classes.eventDetails}>
                                <Typography className={classes.eventZi}>
                                    {event.zi}
                                </Typography>
                                <Typography className={classes.eventData}>
                                    {event.data}
                                </Typography>
                            </Box>
                            <Box className={classes.eventTimeInfo}>
                                <Typography className={classes.eventInterval}>
                                    {event.interval}
                                </Typography>
                                <Typography className={classes.eventDurata}>
                                    {event.durata}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default Caravana;